/** @format */

import { Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import { useDispatch } from 'src/store';
import { setEventTitle } from 'src/slices/events';
import { EventItem as SharedEventItem } from './EventItem';

type EventListItem = {
  title?: string;
  [key: string]: unknown;
};

type EventItemProps = {
  item?: EventListItem;
};

export const EventItem = ({ item }: EventItemProps) => {
  const { title } = item || {};
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(setEventTitle(title || ''));
  };

  return <SharedEventItem item={item} className="archive--list-item" onClick={handleClick} />;
};

const skeletonStyle = { backgroundColor: 'rgba(0, 0, 0, 0.1)' };

export const EventItemSkeleton = () => {
  return (
    <Grid className="events-widget--list-item archive--list-item--skeleton">
      <Grid className="events-widget--list-item-image">
        <Skeleton variant="rectangular" width={64} height={64} style={skeletonStyle} />
      </Grid>
      <Grid className="events-widget--list-item-right">
        <Grid className="events-widget--list-item-header">
          <Grid className="events-widget--list-item-title">
            <Skeleton variant="text" width={180} height={28} style={skeletonStyle} />
          </Grid>
          <Grid className="events-widget--list-item-date">
            <Skeleton variant="text" width={90} height={20} style={skeletonStyle} />
          </Grid>
        </Grid>
        <Grid className="events-widget--list-item-location">
          <Skeleton variant="text" width={140} height={20} style={skeletonStyle} />
        </Grid>
        <Grid className="events-widget--list-item-text">
          <Skeleton variant="text" width="100%" style={skeletonStyle} />
          <Skeleton variant="text" width="70%" style={skeletonStyle} />
        </Grid>
      </Grid>
    </Grid>
  );
};

type EventListSkeletonProps = {
  count?: number;
};

export const EventListSkeleton = ({ count = 5 }: EventListSkeletonProps) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <EventItemSkeleton key={index} />
      ))}
    </>
  );
};
